import { SearchModalWidget } from "./searchModalWidget";
export const SearchModal = (props)=>SearchModalWidget(props).run((_)=>{});
